import Swal from "sweetalert2";

const InitialPopup = {
    general: () => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "liner-light-blue-background",
                cancelButton: "custom-btn liner-light-blue-background me-4 bold-content",
            },
            buttonsStyling: true,
        });
        swalWithBootstrapButtons.fire({
            html: "<p class='swal-text'>All analyses are calculated on the 'Overall sample'. Use the 'Filter across products' toggle to filter the 'Random sample' data</p>",
            width: 500,
            padding: 10,
            color: "#005eef",
            showConfirmButton: true,
            customClass: {
                popup: "custom-swal-popup",
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
    },
};

export default InitialPopup;
